import Text from '@mui/material/Typography'

function Privacy() {
   return (
      <div>
         <div style={{marginTop:10, marginBottom:100}}><Text variant='h6'>Privacy Policy</Text></div>
      </div>
   )
}
export default Privacy